import { useEffect } from "react";
import { CiWarning } from "react-icons/ci";

export default function PaymentCanceled() {

  useEffect(() => {
    setTimeout(() => {
      window.close();
    }, 3000);
  });

  return (
    <div className="relative flex min-h-screen min-h-[100dvh] flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-amber-950 to-slate-900 px-4 py-10">

      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-amber-500/20 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 -right-16 h-80 w-80 rounded-full bg-amber-400/10 blur-3xl"></div>

      <div className="rise relative w-full max-w-[440px] rounded-3xl bg-white p-8 text-center shadow-2xl shadow-slate-950/40 ring-1 ring-white/10">

        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-amber-50 ring-1 ring-amber-100">
          <CiWarning size={44} className="text-amber-500" />
        </div>

        <div className="mt-5 text-xl font-bold tracking-tight text-slate-900">Payment Canceled!</div>

        <div className="mt-3 text-sm leading-relaxed text-slate-500">
          <span dangerouslySetInnerHTML={{ __html: `Your payment has been canceled. If this was a mistake, you can try again or contact our support team for assistance.` }} />
        </div>

        <a href="/" className="mt-7 inline-flex min-h-[44px] w-full items-center justify-center rounded-xl bg-gradient-to-b from-blue-500 to-blue-600 px-4 text-sm font-bold text-white shadow-lg shadow-blue-600/25 transition hover:from-blue-600 hover:to-blue-700">
          Back to Remote VPN
        </a>

      </div>
    </div>
  );
}
